// TanStack Query key factory for chat. Centralizing keys in one file makes
// invalidations from socket-event handlers and mutations easy to audit.

import type { ListRoomsParams, SearchMembersParams } from '../../types/chat';

export const chatKeys = {
  all: ['chat'] as const,

  rooms: (params?: ListRoomsParams) =>
    params ? (['chat', 'rooms', params] as const) : (['chat', 'rooms'] as const),

  room: (roomId: string) => ['chat', 'room', roomId] as const,

  messages: (roomId: string) => ['chat', 'messages', roomId] as const,

  unread: () => ['chat', 'unread'] as const,

  attachments: (roomId: string) => ['chat', 'attachments', roomId] as const,

  tenantMembers: (params?: SearchMembersParams) =>
    params ? (['chat', 'tenantMembers', params] as const) : (['chat', 'tenantMembers'] as const),
};
